// extracted by mini-css-extract-plugin
export default {"wrap":"style_wrap__MqqZt","title":"style_title__0vBPU","subtitle":"style_subtitle__Zw16A","bottom_button":"style_bottom_button__5opic"};